import { useSearchParams } from 'next/navigation'
import { useState } from 'react'

export const useKeyword = () => {
  const searchParams = useSearchParams()
  const keywordParam = searchParams?.get('keyword')

  const [keyword, setKeyword] = useState(keywordParam || '')
  const [focused, setFocused] = useState(false)

  const hasKeyword = () => {
    return keyword.length > 0
  }

  const updateKeyword = (keyword: string) => {
    setKeyword(keyword)
  }

  const updateFocusStatus = (focused: boolean) => {
    setFocused(focused)
  }

  return {
    keyword,
    hasKeyword,
    updateKeyword,
    focused,
    updateFocusStatus,
  }
}
